import { z } from "zod/v3";
import { ZodOutputFor, transformLength } from "../zod-utils";
import { ElementOf } from "@shared/common/types/typeHelpers";
import { Length } from "@shared/common/utils/length";

const TRAIN_UNIT_KINDS = [
  "SNG",
  "VIRM",
  "ICM",
  "SLT",
  "FLIRT",
  "FLIRT FFF",
  "DDZ",
  "ICR",
  "ICNG",
  "ICNG25",
  "ICNGB25",
  "SW7-15V",
  "SW7-25KV",
  "SW9-15V",
  "SW9-25KV",
  "SWB7-25KV",
  "FreightTrain",
  "ThirdParty",
  "Unknown 3rd party",
  "Unknown NS",
] as const;

export type TrainUnitKind = ElementOf<typeof TRAIN_UNIT_KINDS>;
export interface PlanTrainUnit {
  guid: string;
  name: string;
  type: string;
  kind: TrainUnitKind;
  units: number;
  length: Length;
  isThirdParty: boolean;
}
export const planTrainUnitSchema = z
  .object({
    guid: z.string().uuid({ message: "PlanTrainUnit guid should be a valid uuid" }),
    name: z.string().min(1, { message: "PlanTrainUnit name should not be empty" }),
    type: z.string().min(1, { message: "PlanTrainUnit type should not be empty" }),
    kind: z.string(),
    units: z.number().min(1, { message: "PlanTrainUnit should have at least 1 train unit" }),
    lengthInMm: z.number(),
    isThirdParty: z.boolean(),
  })
  .transform((ptu) => ({
    ...ptu,
    kind: z
      .enum(TRAIN_UNIT_KINDS)
      .catch(({ input }) => {
        if (
          !input.toLowerCase().startsWith("onbekend") &&
          !input.toLowerCase().startsWith("unknown")
        ) {
          console.warn(`unknown train unit kind: ${input}`);
        }
        return ptu.isThirdParty ? "Unknown 3rd party" : "Unknown NS";
      })
      .parse(ptu.kind),
  }))
  .transform(transformLength) satisfies ZodOutputFor<PlanTrainUnit>;
